import React from 'react';
import { ISecureImageProps } from '../../models/components/secureImage';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import { ISecureILinkProps } from '../../models/components/ISecureLink';

let _common: Common;
const _logger = Log.create('SecureImage.tsx');

export class SecureLink extends React.Component<ISecureILinkProps, any> {
    public state = { source: '' };
    public constructor(props: ISecureILinkProps) {
        super(props);
        _common = new Common();
    }
    public componentDidMount() {
        fetch(this.props.src, {
            headers: { 'Authorization': 'Bearer ' + _common.GetAuthLocalStorage().access_token }
        }).then((response: any) => {
            if (response.status === 200) {
                return response.text();
            } else {
                this.setState({ source: _common.GetDefaultImages('_document') });
            }
        }).then((data1) => {
            this.setState({ source: data1 });
        })
            .catch((data) => {
                this.setState({ source: _common.GetDefaultImages('_document') });
            });
    }
    public render() {
        return <a style={this.props.style} href={this.state.source} target={this.props.target} download={this.props.download}> {this.props.fileName} </a>;
    }

}